import { LinearProgress } from "@material-ui/core";
import { AttachFile } from "@material-ui/icons";
import React from "react";
import { downloadFile } from "../../../api/FileApi";
import { useListModuleDocumentsQuery } from "../../../api/rtk/ExamSessionCandidateApi";
import DocumentList from "../../common/DocumentList";
import TitleWithIcon from "../../common/TitleWithIcon";
import TranslatedMessage from "../../translations/TranslatedMessage";

interface ExamSessionCandidateAttachmentListProps {
  examSessionCandidateId: string;
  moduleId: string;
}

const ExamSessionCandidateAttachmentList: React.FunctionComponent<ExamSessionCandidateAttachmentListProps> = ({
  examSessionCandidateId,
  moduleId,
}) => {
  const { data: documents, isFetching } = useListModuleDocumentsQuery({ examSessionCandidateId, moduleId });
  return (
    <>
      <TitleWithIcon title={<TranslatedMessage id="examSessionCandidate.attachments" />} variant="h5">
        <AttachFile fontSize="small" />
      </TitleWithIcon>
      {isFetching ? (
        <LinearProgress variant="query" />
      ) : (
        <DocumentList documents={documents ?? []} onDownloadFile={downloadFile} />
      )}
    </>
  );
};

export default ExamSessionCandidateAttachmentList;
